module.exports = __webpack_public_path__ + "static/social-image-f07f4527bf8f65b0108add28368969cf.jpg";